import styled from '@emotion/styled'
import InfoIcon from '@mui/icons-material/Info'
import Input from '@mui/material/Input'

export const MatchHighlight = styled.mark`
  background-color: #b0e9d4;
  border-radius: 5px;
`

export const CustomInfoIcon = styled(InfoIcon)`
  color: #686969;
  margin-top: 4px;
  font-size: 17px;
  margin-left: 5px;
`

export const PreviewDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

export const Container = styled.div`
  position: relative;
  width: 300px;
`

export const HighlightInput = styled(Input)`
  word-break: break-all;
  width: 100%;
  z-index: 1;
`

export const HighlightOverlay = styled.div`
  color: transparent;
  word-break: break-all;
  pointer-events: none;
  padding-top: 4px;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 2;
  font-size: 14px;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  letter-spacing: 0.13px;
  width: 100%;
`
